import { render, staticRenderFns } from "./VehicleShortlist.vue?vue&type=template&id=463947ba&scoped=true&"
import script from "./VehicleShortlist.vue?vue&type=script&lang=js&"
export * from "./VehicleShortlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463947ba",
  null
  
)

export default component.exports